import { Component } from '@angular/core';
import { WebappService } from '../../services/webapp.service';
import { FAQ } from '../../utils/faq';
import { IFaq } from '../../interfaces/i-faq';

@Component({
  selector: 'mobo-faq',
  templateUrl: './faq.component.html',
  styles: [],
})
export class FaqComponent {
  public faqQuestions: any = FAQ.map((faq) => ({ ...faq, isOpen: false }));

  constructor(private webappService: WebappService) {}

  ngOnInit() {
    this.getFAQ();
  }

  getFAQ() {
    this.webappService.getFAQ().then((faq) => {
      this.faqQuestions = (faq as IFaq[]).map((faq) => ({
        ...faq,
        isOpen: false,
      }));
    });
  }
}
